/**
 * epgTimeIndicatorHeader.tsx
 */
import Screen from '@screen';

export default function EpgTimeIndicatorHeader() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={`${19 * Screen.widthRatio}`}
      height={`${16 * Screen.widthRatio}`}
      viewBox='0 0 19 16'
      fill='none'
    >
      <path
        d='M9.09326 15.75L-5.19161e-06 1.7129e-06L18.1865 1.22981e-07L9.09326 15.75Z'
        fill='#FF6200'
      />
    </svg>
  );
}
